import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-policy-page',
  templateUrl: './policy-page.component.html',
  styleUrls: ['./policy-page.component.css']
})
export class PolicyPageComponent implements OnInit {
conditions: any;
generales: any;

  constructor() { }

  ngOnInit(): void {
  }

}
